// /frontend/src/utils/cn.js
import {clsx} from "clsx";
import {twMerge} from "tailwind-merge";

// Combined utility for class name manipulation
export function cn(...inputs) {
    return twMerge(clsx(inputs.filter(Boolean)));
}

